export default {
    excess: 'Draudimo polisas',
    security: 'Saugos depozitas',
    fuel_policy: 'Kuro politika',
    like_for_like: '„Patinka už patinka“',
    full_to_full: 'Pilnas bakas',
    mileage: 'Rida: {mileage} mylios pagal nuomos sutartį',
    unlimited_mileage: 'Neribota rida',
    non_refundable: 'Negrąžinama',
    free_cancellation_until: 'Nemokamas atšaukimas iki {date}',
    cancellation_with_terms: 'Atšaukimas {0} suderintas su ',
    t_c_text: 'Sąlygos',
    two_free_extras: 'Du nemokami priedai paėmimo metu',
    glass_tyres_covered: 'Stiklas ir padangos įtrauktos'
}
